import { withErrorBoundary } from "react-error-boundary"
import ErrorBoundaryFallback from "../ErrorBoundaryFallback"

const withDefaultErrorBoundary = (Component, options) =>
  withErrorBoundary(Component, { FallbackComponent: ErrorBoundaryFallback, ...options })

export default withDefaultErrorBoundary
